module.exports = __webpack_public_path__ + "img/down-live.a783b8ab.svg";